import React from 'react';
import { CardContextProvider, ICardContextProvider } from 'context/cardContext';
import CardView from 'components/Card/components/CardView';

const Card = (props: ICardContextProvider) => {
  return (
    <CardContextProvider {...props}>
      <CardView />
    </CardContextProvider>
  );
};

export default Card;
